import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import I18nProvider from './providers/I18nProvider';
import { RouterProvider } from './providers/RouterProvider';
import App from './App';

import * as Sentry from "@sentry/react";
import reportWebVitals from './reportWebVitals.ts';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.1,
  environment: process.env.NODE_ENV,
});

const root = createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
      <I18nProvider>
        <RouterProvider>
          <App />
        </RouterProvider>
      </I18nProvider>
    </Provider>
);

const sendToGTM = (metric) => {
  const send = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'web_vitals',
        web_vital_name: metric.name,
        web_vital_value: Math.round(metric.value),
        web_vital_id: metric.id,
        web_vital_delta: Math.round(metric.delta)
      });
    } else {
      setTimeout(send, 1000);
    }
  };
  
  send();
};

reportWebVitals(sendToGTM);